import React from 'react';
import background from '../img/hero-background.svg';
import Container from './Container';
import Section from './Section';

const FairProcessingNotice = () => (
    <div>
        <Section dark image={background}>
            <Container>
                <h1>Fair Processing Notice / Privacy Policy</h1>
                <p>Updated: 22nd October 2018</p>

                <h1>Introduction</h1>
                <p>
                    This notice describes your rights as a visitor or customer of Novitalis AG T/A R-Squared Smart
                    Capability Engineering. It provides information about your rights relating to your personal
                    information along with how we collect, use and share your data.
                </p>
                <p>
                    Novitalis AG T/A R-Squared Smart Capability Engineering is committed to abiding by all data
                    protection laws in the countries in which it operates and will be open and transparent in how we use
                    your personal information. Many people will be aware of the General Data Protection Regulation
                    (GDPR) and as an organisation based in Switzerland, but with clients globally, we understand our
                    obligations in keeping and managing personal data responsibly, lawfully and transparently.
                </p>
                <p>
                    Novitalis AG T/A R-Squared Smart Capability Engineering acknowledges its requirement to comply with
                    these laws as well as local laws applicable to other countries and so intends to abide by the GDPR
                    requirements alongside Swiss data protection legislation which is enforced by the Swiss Federal Data
                    Protection and Information Commissioner (DPIC).
                </p>
                <p>
                    As a global organisation we have written this policy to reflect international data processing, and
                    reference GDPR requirements for transparency and openness.
                </p>
                <p>
                    This policy contains links to more information on many of the topics listed and further external
                    links if you wish to read further detail about personal data management.
                </p>
            </Container>
        </Section>
        <Section>
            <Container>
                <h1>Who we are</h1>
                <p>
                    Novitalis AG T/A R-Squared Smart Capability Engineering is a talent acquisition and solutions
                    provider, with our roots in executive search and assessment. More information about what we do can
                    be found on our web pages. Question related to privacy and data protection can be directed to:
                </p>
                <p>
                    <strong>Björn Stapela</strong>
                    <br />
                    Loerracherstrasse 50
                    <br />
                    4125 Riehen
                    <br />
                    Switzerland
                    <br />
                    Email: GDPR@r-squared.ch
                </p>
                <h1>What is personal data?</h1>
                <p>
                    Personal data is data which identifies a person (you) from the information provided or if combined
                    with information that we may already have access to. You can find out more about the GDPR
                    definitions of personal data here. In summary, personal data can be anything that enables an
                    individual to be identified, for example: Name and address Date of birth Email address Bank account
                    details An IP address In addition, there are “special categories” of personal data which means that
                    the data, in law, is considered more sensitive, for example: Personal data related to your health
                    Genetic data Religious beliefs Click <a href="https://gdpr-info.eu/art-9-gdpr/">here</a> for a more
                    complete list of this type of data.
                </p>
                <h1>Collecting personal data</h1>
                <p>
                    We collect your personal data for a number of reasons including to enable us to identify potential
                    roles for which your skills would be suitable or to inform you about professional opportunities with
                    respect to your organisation’s recruitment and retention of staff. Your personal data may be
                    collected from several places. The information we collect about you can come from:
                    <ul>
                        <li>Information you have provided whilst enquiring about services</li>
                        <li>Forms on the website or on paper which you have completed</li>
                        <li>Information provided over the telephone</li>
                        <li>Information you have provided via email correspondence with us</li>
                        <li>Third parties supplying your information (see below)</li>
                    </ul>
                    We will usually collect information you have provided, but sometimes we get your personal
                    information from third parties that provide us with the personal data of people who have given
                    permission for their information to be shared. In addition we may use publicly available sources to
                    identify you. We will always use such information responsibly and in accordance with your rights.
                    Click here for a list of categories of third parties. We may get your information from third
                    parties, where your permission is given or there is a valid legal basis for obtaining it, from:
                    <ul>
                        <li>Professional networking websites</li>
                        <li>Referrals from third parties</li>
                        <li>Professional list generators</li>
                    </ul>
                    Where your personal data is used by us, you will always be afforded the option of stopping further
                    contact, “unsubscribe” and controlling these consent options to your own satisfaction. It is always
                    our intention to use your personal data lawfully and reasonably. If you believe that we have misused
                    your personal data, please contact us and we will resolve your problem as swiftly as we can.
                </p>
                <h1>What we use your personal data for</h1>
                <p>
                    We will use your personal data to assess your suitability for potential roles, based on your
                    professional attributes and to let you know that such opportunities arise.{' '}
                </p>
                <p>
                    We will use your personal data to administer any accounts you may have and to ensure that we fulfil
                    any contractual obligations as well as fulfil Novitalis AG T/A R-Squared Smart Capability
                    Engineering’s legitimate business interests.
                </p>
                <p>
                    <strong>
                        We will use your personal data, with your permission, to provide to third parties who you may be
                        interested in hearing from. We will always ensure we have your permission to do this before we
                        share.
                    </strong>
                </p>
                <p>
                    You may, at any time, contact us to request us to stop using your personal data and we will respect
                    this right.
                </p>
                <h1>Consent and Permissions</h1>
                <p>
                    It is important to us that you are happy with how we contact you and that you have control over
                    these contacts where marketing is concerned. We may use a number of consent methods to ensure that
                    you get the information want and need with as little hassle as possible.
                    <ol>
                        <li>
                            Opt-In – We will ask you to indicate your preference in how we use your personal information
                            when we are collecting it.
                        </li>
                        <li>
                            Confirmed Opt-In – Also known as double opt-in, this is used in some countries, notably
                            Canada and Germany and we will always abide by the laws of the countries in which we
                            operate. This method involves seeking your consent (opt-in) and then confirming this,
                            usually via email, to ensure that you are happy to be contacted further.
                        </li>
                    </ol>
                </p>
                <h1>Who do we share your personal data with?</h1>
                <p>
                    There are some organisations with which we work where we must share your personal details to provide
                    the service you require, for example business partners and support providers. Where your personal
                    data must be shared for us to provide you with a service, then we make sure that our partners have
                    the right controls in place to use your information responsibly and under our control. Categories of
                    partners who may see your information are listed here.
                    <ul>
                        <li>Partner network members</li>
                        <li>Consulting organisations</li>
                        <li>Client organisations (recruiting talent)</li>
                        <li>Finance providers, as part of our finance systems</li>
                    </ul>
                    It is important for us that you understand who your information may be shared with and the
                    seriousness with which we take the confidentiality of your personal data. If you have questions
                    about such uses of your personal data, we will be happy to tell you more. We may also share your
                    information with organisations where there is a need to check the accuracy of data we hold and where
                    there may be legal or regulatory requirement to provide personal data, for example, law enforcement.
                    We will not share your personal data unless there is a valid legal reason or need to do so.
                </p>
                <h1>Where is your personal data kept?</h1>
                <p>
                    Your personal data is kept secure at all times and we use the latest technology to ensure that all
                    our data is kept confidential, especially personal information that we hold. Your information may be
                    kept in a number of places, all of which comply with data protection requirements. We use cloud
                    providers and online application providers to help us run our business. Personal data may be held on
                    systems and databases in several locations. However, your personal information will be held securely
                    and confidentially and with suitable legal agreements and contracts in place, so you can be assured
                    that your personal data is looked after. Some of our systems may include the transfer of your
                    personal data to other countries. Your data will only be transferred to other countries which have
                    adequate provision in place to protect personal data.
                </p>
                <h1>How long we keep your personal data for</h1>
                <p>
                    We will keep your personal data for a length of time that is in line with our need to identify you
                    and to provide services to you. If you are an individual professional, then we will keep personal
                    information about you for our legitimate business purposes and to ensure that you get to know about
                    opportunities in which you may be interested. We will also use your information to ensure that we do
                    not contact you inadvertently if you have refused marketing contact. We will only keep your personal
                    data for as long as there is a legitimate requirement to do so.
                </p>
                <h1>Website technology (Cookies)</h1>
                <p>
                    Our website can use technologies to capture and analyse activity on our website. We can use this
                    technology to help us understand and enhance the visitor experience, improve our rankings in Search
                    engines, and ensure your visit to our website and any data you supply is processed legally and
                    securely. We do our best to secure and minimise the risk, at all times, to any data you supply. We
                    use some cookies on our website to enable us to understand how our website is being used. We use
                    Google Analytics cookies but do not use any third-party cookies which track your activity. for more
                    information about cookies and how to control them via your browser, please see
                    www.allaboutcookies.org.
                </p>
                <h1>Third-party services</h1>
                <p>
                    We work with the following third-party data processors. For each of them, we have a GDPR compliant
                    data processing agreement.
                </p>
                <h2>Google Cloud in Zurich, Switzerland</h2>
                <p>
                    We are hosting our website and database at the Google Cloud in Switzerland. The database stores
                    following data:
                </p>
                <ul>
                    <li>Your email addresses</li>
                    <li>Your first and last name</li>
                    <li>Application questions</li>
                </ul>
                <h2>Cloudinary</h2>
                <p>
                    We use services from Cloudinary to store and process videos and documents. This data is
                    automatically deleted after it is no more used.
                </p>
                <h2>Amazon Web Services</h2>
                <p>
                    We use Amazon Web Services to authenticate administrators and hiring managers. The following data is
                    stored:{' '}
                </p>
                <ul>
                    <li>Your first and last name</li>
                    <li>Your email address</li>
                    <li>Your phone number</li>
                </ul>
                <p>For candidates, we don't store or process any data on Amazon Web Services.</p>
                <h2>Sentry</h2>
                <p>
                    To detect problems and errors as soon as possible and improve the quality of the product we use
                    sentry.io. We only collect the data necessary to fix issues. We do not collect IP addresses.
                </p>
                <h1>What are your rights?</h1>
                <p>
                    Under the General Data Protection Regulation and other local data protection laws, you have rights
                    over how your personal data is used. The main rights related to your personal data are listed below,
                    but there are others which you may like to find out more about by looking up the General Data
                    Protection Regulation.
                </p>
                <h2>The right of transparency (right to be informed)</h2>
                <p>
                    You have a right to be informed about the collection and use of your personal data. We have an
                    obligation to be transparent and provide you with this information freely and that it is easily
                    understood. This notice serves to provide information on collection and use of personal data, and
                    you may contact us if you want to know more about any aspect of how we handle your personal
                    information. More information on this right is available{' '}
                    <a href="https://gdpr-info.eu/art-12-gdpr/">here</a>. If you require more information relating to
                    any of this privacy notice, please contact us using the details above.
                </p>
                <h2>The right of access to your information</h2>
                <p>
                    You have a right to have access to the information we hold about you and to verify that we are using
                    your personal data lawfully. If asked, we will provide confirmation of what personal data we hold,
                    provide a copy of the data, and inform you of any other rights you may have. You can find out more
                    about what you are entitled to request by clicking{' '}
                    <a href="https://gdpr-info.eu/art-15-gdpr/">here</a>. If you would like to make such a request,
                    please contact us using the details above.
                </p>
                <h2>The right of rectification</h2>
                <p>
                    You have the right to have any information held about you which is inaccurate to be rectified. If
                    you believe that we have inaccurate information, for example a misspelt name, then please contact us
                    and we will do our utmost to sort the issue. More about rectification can be found{' '}
                    <a href="https://gdpr-info.eu/art-16-gdpr/">here</a>.
                </p>
                <h2>The right to be forgotten (the right to erasure)</h2>
                <p>
                    You have, subject to certain conditions being met, the right to be forgotten. Where we can, we will
                    remove all your details from our systems subject to being able to do so reasonably, and where no
                    other legal or legitimate reason exists to keep your personal data. Please look{' '}
                    <a href="https://gdpr-info.eu/art-17-gdpr/">here</a> for more information on this right. If you
                    would like to make such a request, please contact us using the details above.
                </p>
                <h2>The right to restrict processing of your personal data</h2>
                <p>
                    In some cases, you may require us to hold your data but not process it, this may be relevant if you
                    believe inaccuracies have not been corrected and further processing would affect your rights and
                    freedoms as laid out in the law, as an individual. More information on this right can be found{' '}
                    <a href="https://gdpr-info.eu/art-18-gdpr/">here</a>.
                </p>
                <h2>The right to data portability</h2>
                <p>
                    Personal data portability means that on request we will give you the information we hold about you
                    in a form that can easily be used by other systems. This is most likely to be a spreadsheet file so
                    that you may pass this information on to other organisations with which you would like to share the
                    data. It may not always be possible to give you everything about you in this format, but we will
                    always strive to provide what we can for you. Click{' '}
                    <a href="https://gdpr-info.eu/art-20-gdpr/">here</a> for more information.
                </p>
                <h2>The right to object</h2>
                <p>
                    You have a right to object to how personal data about you is processed, in some instances. You may
                    object to us processing your personal data for our “legitimate interests”, to stop direct marketing
                    and the processing your personal data for research or statistical purposes. Unless we can
                    demonstrate compelling reasons for continuing to process your personal data which we will explain to
                    you if relevant when you object, we will always endeavour to comply with your wishes. You may find
                    out more about this right, <a href="https://gdpr-info.eu/art-21-gdpr/">here</a>.
                </p>
                <h2>The right to stop automated individual decision making, including profiling</h2>
                <p>
                    Should we wish to carry out any automated decision making or profiling of you, using your personal
                    data, then we will abide by the law and only do this where we may legally do so. Any decisions made
                    automatically about you will be made obvious to you, where they have a direct effect on you and your
                    rights and freedoms. You will always have the ability to contact us and query these activities and
                    request that they stop or have human intervention, and you can request not to be profiled at any
                    time. We aim to be transparent and open about this type of data processing so that you can feel
                    assured that your data is safe, kept confidential and always used lawfully and fairly. Details about
                    this right can be found <a href="https://gdpr-info.eu/art-22-gdpr/">here</a>.
                </p>
                <h2>The right to complain</h2>
                <p>
                    You have a right to complain to the regulator in the country in which you reside or where you
                    believe any misuse of your data has taken place. However, we would always ask that you allow us to
                    attempt to resolve any issue you have in the first instance by contacting us, using the details
                    above.
                </p>
                <h1>Links to other websites</h1>
                <p>
                    Our Site may include links to other Websites whose privacy practices may differ from ours. If you
                    submit personal information to any of those sites, your information is governed by their privacy
                    policies. We encourage you to carefully read the privacy policy of any Website you visit. If you
                    chose to follow one of these links, you do so at your own risk.
                </p>
                <p>
                    Novitalis AG T/A R-Squared Smart Capability Engineering is not responsible for the accuracy or
                    reliability of any information, data, opinion, software, advice, content or statements contained on
                    third-party websites, or for the quality of any products or services available on these websites.
                </p>
                <p>
                    If you chose to provide any personal information to a third-party website, you do so at your own
                    risk. Ensure you have read and understood the third-party privacy notice/policy. We cannot guarantee
                    that any information you provide will not be misused or disclosed to other third parties by means
                    beyond our control.
                </p>
                <p>This privacy notice will be amended from time to time, any changes will be reflected her.</p>
            </Container>
        </Section>
    </div>
);

export default FairProcessingNotice;



// WEBPACK FOOTER //
// ./src/components/FairProcessingNotice.tsx